import {Injectable} from "@angular/core";
import {LoadingScreenService} from "../../../services/loading-screen/loading-screen.service";
import {GlobalService} from "../../../global.service";
import {Router} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {FlashApiService} from "./flash-api.service";
import {formatDate} from "@angular/common";
import {EncryptWithKeyService} from "./encrypt-with-key.service";
import DeviceConnectionInformation, {
  AuthorizationRequest,
  GetTransactionStatusRequest,
  PaymentOption,
} from "../interfaces/flash-payment-interface";
import {VARS_NEEDED} from "../constants/flash-payment-constants";
import {Subject, Subscription} from "rxjs";
import {FlashPaymentUtil} from "../util/flash-payment.util";
import {MatDialog} from "@angular/material/dialog";
import {DialogConfirmComponent} from "../../components/dialog-confirm/dialog-confirm.component";

declare let P: any;

@Injectable({
  providedIn: "root",
})
export class FlashController {
  controller = VARS_NEEDED;
  mustOpenForm = new Subject();
  listenACH: Subscription;
  count = 0;
  personalizedMessages: any;

  constructor(
    private loadingScreenService: LoadingScreenService,
    private global: GlobalService,
    private router: Router,
    private service: FlashApiService,
    public _sanitizer: DomSanitizer,
    private encryptWithKeyService: EncryptWithKeyService,
    public dialog: MatDialog
  ) {
    const expDate = FlashPaymentUtil.formatFromPickerToServer(
      this.controller.today
    );
    this.controller.expirationDate = expDate;
    this.initData();

    console.log('loader fix version')
  }

  initData() {
    this.count = 0;
    this.controller.jstoday = formatDate(
      this.controller.today,
      "dd-MM-yyyy hh:mm:ss a",
      "en-US",
      "+0530"
    );
    this.controller.expirationYear = this.controller.jstoday.substring(6, 10);
    this.controller.expirationMonth = this.controller.jstoday.substring(3, 5);
    this.controller.cardNumber = "";
    this.controller.cardNumberString = "";
    this.controller.ccv = "";
    this.controller.paymentMethod = '';
    this.controller.authorizationNumber = '';
    this.controller.paymentStatusDesription = '';
    this.controller.tokenInstrumentId = 0;
    this.controller.step1 = true;
    this.controller.step2 = false;
    this.controller.step3 = false;
    this.controller.cardSelected = null;
    this.controller.isPlaceToPay = false;
    this.controller.isACH = false;
    this.controller.isCard = true;
    this.controller.canActivateTokenizationProcess = false;
    this.controller.confirmationNumber = '';
    this.controller.disabledBtn = false;
    this.selectCard({id: -1});
    this.service.getIPAddress().subscribe(
      (data: any) => {
        this.controller.ipAddress = data.ip;
      }, error => {
        this.controller.ipAddress = '0.0.0.0';
      }
    );
  }

  stepUpdate(step: number) {
    if (step === 1) {
      this.checkWayProcess();
    } else if (step === 2) {
      this.controller.disabledBtn = true;
      this.executAuthorizePayment();
    } else {
      this.loadingScreenService.startLoading();
      setTimeout(() => {
        this.loadingScreenService.stopLoading();
        this.controller.step3 = true;
        this.controller.operationSuccess = true;
      }, 2000);
    }
  }

  checkWayProcess() {
    this.loadingScreenService.stopLoading();
    if (this.controller.isACH) {
      this.controller.step1 = false;
      this.achProcess();
    } else if (this.controller.isCard) {
      this.controller.step1 = false;
      this.cardProcess();
    } else {
      this.loadingScreenService.startLoading();
      this.placeToPayProcess();
    }
  }

  placeToPayProcess() {
    this.continueToStep2();
  }

  cardProcess() {
    if (!this.controller.name) {
      this.global.notif("El nombre de usuario es obligatorio");
      this.controller.step1 = true;
      return;
    }

    if (FlashPaymentUtil.isInvalidCharacter(this.controller.name)) {
      this.global.notif("Nombre inválido");
      this.controller.step1 = true;
      this.controller.name = '';
      return;
    }

    if (!this.validateCreditCardForm) {
      this.controller.step1 = false;
      return;
    }

    if (this.controller.cardNumberString === "") {
      this.global.notif("Debe introducir una tarjeta");
      this.controller.step1 = true;
      return;
    }

    if (this.controller.paymentMethod != "A") {
      if (this.controller.ccv === "") {
        this.global.notif("ccv es un campo obligatorio");
        this.controller.step1 = true;
        return;
      }
    }

    if (this.controller.expirationYear && this.controller.expirationMonth) {
      this.controller.expirationDate = `${this.controller.expirationYear}/${this.controller.expirationMonth}`;
    } else {
      this.global.notif("La fecha de expiración es obligatoria");
      this.controller.step1 = true;
      return;
    }

    if (!this.controller.PostalCode) {
      this.global.notif("El código postal es obligatorio");
      this.controller.step1 = true;
      return;
    }

    this.controller.cardFormComplete = true;
    this.loadingScreenService.startLoading();
    if (this.controller.paymentMethod === "A") {
      if (this.count === 0) {
        this.count += 1;
        window.scroll(0, 5000);
        this.buildAuthorizationRequest(true);
      }

    } else {
      this.continueToStep2();
    }
  }

  achProcess() {
    this.controller.achFormComplete = true;
    this.loadingScreenService.startLoading();
    window.scroll(0, 700);
    this.continueToStep2();
  }

  continueToStep2() {
    setTimeout(() => {
      this.loadingScreenService.stopLoading();
      this.controller.step2 = true;
    }, 1000);

    setTimeout(() => {
      window.scrollTo(0,10000);
    }, 1200);

  }

  getTokenCards() {
    const payload = {
      customerEmail: atob(sessionStorage.getItem("email")),
      accountNumber: atob(sessionStorage.getItem("currentBan")).toString(),
      source: 'MICLARO',
      externalId: atob(sessionStorage.getItem("userId"))
    };
    const dto = this.encryptWithKeyService.encryp(JSON.stringify(payload));
    this.loadingScreenService.startLoading();
    this.service
      .getTokenCards(dto)
      .subscribe(
        (data: any) => {
          this.loadingScreenService.stopLoading();
          const respString: string = this.encryptWithKeyService.decrypt(
            data.dataToken
          );
          const resp = JSON.parse(
            FlashPaymentUtil.formatEncryptData(respString)
          );
          this.controller.tokenCards = resp.TokenCards;
          if (this.controller.tokenCards.length > 0) {
            this.mustOpenForm.next(false);
          } else {
            this.mustOpenForm.next(true);
          }
        },
        (error) => {
          this.loadingScreenService.stopLoading();
          this.global.notif(error);
          this.mustOpenForm.next(true);
        }
      );
  }

  selectCard(card) {
    this.controller.tokenizedCCV = "";
    this.controller.tokenCards.forEach((item) => {
      if (item.id === card.id) {
        item.active = "active";
        this.controller.paymentMethod = item.brandCode;
        this.controller.tokenInstrumentId = item.id;
        this.controller.cardSelected = item;
        if (item.payerName) {
          this.controller.name = item.payerName;
        }
      } else {
        item.active = "";
      }
    });
  }

  deleteCard(card) {
    this.openDialog(2, card);
  }

  startDeleteAction(card) {
    const payload = {
      tokenId: card.id,
      source: "MICLARO"
    };
    const dto = this.encryptWithKeyService.encryp(JSON.stringify(payload));
    this.loadingScreenService.startLoading();
    this.service.deleteInstrument(dto).subscribe(
      (data: any) => {
        this.loadingScreenService.stopLoading()
        const respString: string = this.encryptWithKeyService.decrypt(data.dataToken).toString();
        if (respString.includes('"hasError":false')) {
          this.global.notif('Tarjeta eliminada correctamente');
          this.getTokenCards();
        } else {
          this.global.notif('Ha ocurrido un error al intentar completar la operación, por favor intente nuevamente más tarde')
        }
      }, error => {
        this.global.notif('Ha ocurrido un error al intentar completar la operación, por favor intente nuevamente más tarde')
      }
    );
  }

  isValidCreditCardNumber(cardNumber) {
    this.controller.isValidCard = true;
    this.controller.isTheCardNumberEmpty = false;
    if (FlashPaymentUtil.VisaCardnumber(cardNumber)) {
      this.controller.cardType = "VISA";
      this.controller.paymentMethod = "V";
    } else if (FlashPaymentUtil.MasterCardnumber(cardNumber)) {
      this.controller.cardType = "MASTER CARD";
      this.controller.paymentMethod = "M";
    } else if (FlashPaymentUtil.AmexCardnumber(cardNumber)) {
      this.controller.cardType = "AMERICAN EXPRESS";
      this.controller.paymentMethod = "X";
    } else if (FlashPaymentUtil.DiscoverCardnumber(cardNumber)) {
      this.controller.cardType = "DISCOVER";
      this.controller.paymentMethod = "D";
    } else if (FlashPaymentUtil.DinerClubCardnumber(cardNumber)) {
      this.controller.cardType = "DINERCLUB";
      this.controller.paymentMethod = "DIN";
    } else if (FlashPaymentUtil.JCBCardnumber(cardNumber)) {
      this.controller.cardType = "JCB";
      this.controller.paymentMethod = "J";
    } else if (FlashPaymentUtil.ATHcardnumber(cardNumber)) {
      this.controller.cardType = "ATH";
      this.controller.paymentMethod = "A";
    } else {
      this.controller.cardType = "invalid card type";
    }


    if (this.controller.cardType === "invalid card type") {
      this.controller.isValidCard = !this.controller.isValidCard;
      this.controller.cardNumberString = "";
    } else {
      this.controller.cardNumber = this.controller.cardNumberString;
      this.controller.cardNumberString =
        "************" +
        this.controller.cardNumber.substring(
          13,
          this.controller.cardNumber.length
        );
    }
    return this.controller.cardType;
  }

  ccvChanged() {
    this.controller.isTheCcvError = false;
    if (this.controller.ccv !== "") {
      this.controller.isTheCcvEmpty = false;
    }

    if (this.controller.ccv.length < 3) {
      this.controller.isTheCcvError = true;
    }
  }

  zipCodeChanged() {
    this.controller.isValidZip = true;
    this.controller.isEmptyZipCode = false;
    if (FlashPaymentUtil.isNumericValidCharacter(this.controller.PostalCode)) {
      this.controller.PostalCode = "";
      this.controller.isValidZip = false;
      return;
    }
    if (this.controller.PostalCode !== "") {
      if (this.controller.PostalCode.length !== 5) {
        this.controller.isValidZip = false;
      }
    } else {
      this.controller.isEmptyZipCode = true;
    }
  }

  validateCreditCardForm() {
    let canContinue = true;
    if (this.controller.cardNumberString === "") {
      this.controller.isTheCardNumberEmpty = true;
      canContinue = false;
    }

    if (this.controller.ccv === "") {
      if (this.controller.paymentMethod != "A") {
        canContinue = false;
        this.controller.isTheCcvEmpty = true;
      } else {
        canContinue = true;
      }
    }

    if (this.controller.cardIsExpired) {
      canContinue = false;
    }

    if (this.controller.isEmptyZipCode || !this.controller.isValidZip) {
      canContinue = false;
    }
    return canContinue;
  }

  changeExpirationMonth() {
    if (
      this.controller.expirationYear ===
      this.controller.jstoday.substring(6, 10) &&
      Number(this.controller.jstoday.substring(3, 5)) >
      Number(this.controller.expirationMonth)
    ) {
      this.controller.cardIsExpired = true;
    } else {
      this.controller.cardIsExpired = false;
    }
  }

  goBack() {
    this.initData();
    this.global.refreshDataTo(sessionStorage.getItem('token'));
  }

  pay() {
    if (!this.controller.step3) {
      if (this.count === 0) {
        this.count += 1;
        this.buildAuthorizationRequest(false, false, false, false, true);
      }

    } else {
      this.openDialog(1);
    }

  }

  openDialog(type: number, card = null): void {
    let message;
    if (type === 1) {
      message = 'Acabas de ralizar un pago, ¿Deseas realizar otro pago?';
    } else {
      message = `Seguro que desea eliminar la tarjeta ${card.franchiseName} XXXX-XXXX-XXXX- ${card.lastFourDigits}`;
    }
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: 'auto',
      data: {message, type, card},
    });

    dialogRef.afterClosed().subscribe(result => {
      // TODO: sacar la os datos del modal
    });
  }

  activateTokenCard() {
    setTimeout(() => {
      // TODO
    }, 200);
  }

  buildAuthorizationRequest(
    isAth = false,
    isSubscription = false,
    isApiCard = false,
    isTokenizedCardSubscription = false,
    isPaymentWithStoredInstrument = false
  ) {
    this.loadingScreenService.startLoading();
    if (isAth) {
      this.controller.paymentOptionSelected = this.findEnabledOption("ATH");
    } else if (isApiCard || isPaymentWithStoredInstrument) {
      this.controller.paymentOptionSelected =
        this.findEnabledOption("APICALLMETHOD");
    } else {
      this.controller.paymentOptionSelected = this.findEnabledOption("WALLET");
      if (this.controller.tokenInstrumentId !== 0) {
        isPaymentWithStoredInstrument = true;
      }
    }
    const payload: any = {
      customer: {
        accountNumber: atob(sessionStorage.getItem("currentBan")).toString(),
        customerName: JSON.parse(sessionStorage.getItem("accountInfo"))
          .firstNameField,
        customerLastName: JSON.parse(sessionStorage.getItem("accountInfo"))
          .lastNameField,
        customerEmail: atob(sessionStorage.getItem("email")),
        subscriberNumber: atob(sessionStorage.getItem("currentSuscriber")),
        buyerName: this.controller.name.split(' ')[0],
        buyerLastName: this.controller.name.split(' ')[1],
        address: {
          address1: "", // this.controller.direction.toString().trim() ? this.controller.direction.toString().trim() : JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line2Field,
          address2: "", // this.controller.direction2 ? this.controller.direction2.toString().trim() : JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line1Field? JSON.parse(sessionStorage.getItem("accountInfo")).addressLinesField.line1Field: "",
          city: "", //JSON.parse(sessionStorage.getItem("accountInfo")).cityField,
          state: "", //JSON.parse(sessionStorage.getItem("accountInfo")).stateField,
          zipCode: this.controller.PostalCode, // JSON.parse(sessionStorage.getItem("accountInfo")).zIPField,
        },
        transactionDescription: "Pago",
        transactionAmount: isSubscription
          ? 0
          : Number(this.controller.operationAmount),
      },
      client: {
        ipAddress:  this.controller.ipAddress,
        userAgent: navigator.userAgent.toLowerCase(),
      },
      payment: {
        cardNumber: isAth || isApiCard ? this.controller.cardNumber : "",
        expirationDate:
          isAth || isApiCard
            ? this.controller.expirationMonth + this.controller.expirationYear
            : "",
        securityCode: isApiCard || isPaymentWithStoredInstrument ? this.controller.ccv : "",
        paymentMethod:
          isAth || isApiCard || isPaymentWithStoredInstrument
            ? this.controller.paymentMethod
            : "",
        amount:
          isSubscription || isTokenizedCardSubscription
            ? 0
            : Number(this.controller.operationAmount),
      },
      subscription: {
        expirationDate:
          isSubscription || isTokenizedCardSubscription
            ? `${
              this.controller.expirationMonth
            }/${this.controller.expirationYear.substring(
            2,
            this.controller.expirationYear.length
            )}`
            : "",
        cardNumber:
          isSubscription || isTokenizedCardSubscription
            ? this.controller.cardNumber
            : "",
        securityCode:
          isSubscription || isTokenizedCardSubscription
            ? this.controller.ccv
            : "",
        merchantId: isSubscription ? 16 : isTokenizedCardSubscription ? 18 : 0,
        brandCode: "",
        source:"MICLARO",
        tokenInstrumentId: 0,
        subscriptionActions: 0,
        externalId: atob(sessionStorage.getItem("userId"))
      },
      paymentToken: sessionStorage.getItem("token") + Math.random() * 10000,
      paymentOptionId:  isSubscription || isTokenizedCardSubscription
        ? 0
        : this.controller.paymentOptionSelected.id,
      transactionType: isSubscription ? 3 : 0,
      doProvisioningIndicator: 1,
      parentPaymentId: 0,
      externalId: "",
      locationId: this.controller.locationId,
      installmentUnits: this.controller.quantityToAccelerate,
      transactionDescription: "Pago",
      invoiceNumber: this.controller.invoiceNumber
    };

    if (this.controller.tokenInstrumentId !== 0) {
      payload.payment.tokenInstrumentId =
        isSubscription || isTokenizedCardSubscription
          ? 0
          : this.controller.tokenInstrumentId;
    } else {
      payload.payment.tokenInstrumentId = 0;
    }
    const dto = this.encryptWithKeyService.encryp(JSON.stringify(payload));
    if (isTokenizedCardSubscription) {

      this.tokenizeCard(dto);
    } else {
      this.createTransaction(
        dto,
        isSubscription,
        isAth,
        isApiCard,
        isPaymentWithStoredInstrument
      );
    }
  }

  findEnabledOption(typeProcess: string) {
    const Options: PaymentOption[] = this.controller.paymentOptions;
    let optionSelected = null;
    Options.forEach((element, index) => {
      if (
        element.merchantTypeCode.toString().trim().toLowerCase() ===
        typeProcess.trim().toLowerCase()
      ) {
        optionSelected = element;
      }
    });
    return optionSelected;
  }

  async createTransaction(
    request,
    isSubscription,
    isAth = false,
    isApiCard = false,
    isPaymentWithStoredInstrument = false
  ) {
    this.loadingScreenService.startLoading();
    this.service.getTransactionAuthorizationEncrypt(request).subscribe(
      (data) => {
        let decryptedData = null;
        let correctObject = null;
        const respString: string = this.encryptWithKeyService.decrypt(data.dataToken);
        try {
          correctObject = JSON.parse(FlashPaymentUtil.formatEncryptData(respString));
          decryptedData = correctObject;
          this.decide(decryptedData, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument);
        } catch (e) {
          this.tryWithService(data.dataToken, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument);
        }
      },
      (error) => {
        this.manageErrorCreateTransaction()
      }
    );
  }

  decide(decryptedData, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument) {
    if (decryptedData) {
      this.manageCreateTransactionData(decryptedData, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument);
    } else {
      this.manageErrorCreateTransaction();
    }
  }

  tryWithService(token, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument) {
    this.service.decryptTokenByCrypto(token).subscribe(
      (data: any) => {
        const respString: string = data.dataToken.replace('pIvhi9.qodmyxcyhqow.', "");
        const decryptedData = JSON.parse(atob(atob(atob(respString))));
        if (decryptedData) {
          this.decide(decryptedData, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument);
        } else {
          this.manageErrorCreateTransaction();
        }
      }, error => {
        this.manageErrorCreateTransaction();
      }
    );
  }

  manageCreateTransactionData(resp, isSubscription, isAth, isApiCard, isPaymentWithStoredInstrument) {
    if (!resp.hasError) {
      this.loadingScreenService.stopLoading();
      const paymentID = resp.paymentId;
      sessionStorage.setItem("paymentID", paymentID);
      sessionStorage.setItem("flash-data", JSON.stringify(this.controller));
      if (!isAth && !isApiCard && !isPaymentWithStoredInstrument) {
        this.lightBoxProcess(resp, isSubscription, paymentID);
      } else {
        if (isAth) {
          this.athProcess(resp);
        } else if (isApiCard || isPaymentWithStoredInstrument) {
          this.apiCallProcess(resp);
        }
      }
    } else {
      this.loadingScreenService.stopLoading();
      this.controller.errorMessage = resp.errorDisplay;
      if (isApiCard || isPaymentWithStoredInstrument) {
        this.apiCallProcess(resp);
      } else {
        this.showLastStepOperation(3);
      }
    }
  }

  lightBoxProcess(resp, isSubscription, paymentID) {
    const processUrl: string = resp.webCheckOutAttribute.checkOutUrl;
    P.init(processUrl);

    P.on("response", (data) => {
      if (this.count === 0) {
        this.count += 1;
        if (!isSubscription) {
          this.controller.step1 = false;
          if (data.status.status === "PENDING" || data.status.status === "REJECTED") {
            this.buildTransactionStatusRequest(Number(data.reference), "");
            // this.buildTransactionStatusRequest(paymentID, "");

          } else {
            this.buildTransactionStatusRequest(Number(data.reference), ""); // TODO remove else
          }
        } else {
          if (data.status.status !== "REJECTED") {
            this.global.notif("Suscripcion realizada con exito");
          }
        }
      }

    });
  }

  athProcess(resp) {
    const processUrl: string =
      resp.athPinPadMethodAttributes.checkOutUrl;
    this.controller.athURL =
      this._sanitizer.bypassSecurityTrustResourceUrl(processUrl);
    this.continueToStep2();
  }

  apiCallProcess(resp) {
    window.scroll(0, 700);
    if (
      resp.apiCallMethodAttributes.transactionInfo.payment
        .authorizationNumber
    ) {
      this.controller.authorizationNumber =
        resp.apiCallMethodAttributes.transactionInfo.payment.authorizationNumber;

      this.controller.paymentStatusDesription =
        // resp.apiCallMethodAttributes.transactionInfo.StatusDesription;
        resp.errorSubject;
      this.controller.paymentMethod = resp.apiCallMethodAttributes.transactionInfo.payment.method.toString().trim().toUpperCase(); // corregir aca


      if (
        !resp.hasError
      ) {
        this.controller.confirmationNumber =
          resp.apiCallMethodAttributes.transactionInfo.provisioning.referenceSequenceCode;
        this.controller.paymentStatusDesription = this.personalizedMessages.okMessage;
        this.count = 0;
        this.showLastStepOperation(1);
      } else {
        this.controller.warningDescription =
          resp.apiCallMethodAttributes.transactionInfo.provisioning.errorDisplay;
        this.showLastStepOperation(2);
      }

      if (
        !resp.apiCallMethodAttributes.transactionInfo.subscription
          .token
      ) {
        this.controller.showSubscriptionOption = true;
      }

      if (this.controller.canActivateTokenizationProcess) {
        if (this.count === 0) {
          this.count += 1;
          this.buildAuthorizationRequest(
            false,
            false,
            false,
            true,
            false
          );
        }

      }
    } else {
      this.showLastStepOperation(3);
    }
  }

  manageErrorCreateTransaction() {
    this.loadingScreenService.stopLoading();
    const message = 'Ha ocurrido un error con su token de usuario, pruebe cerrar la session y vuelva a intentar';
    this.global.notif(message);
  }


  tokenizeCard(payload) {
    this.loadingScreenService.startLoading();
    this.service.tokenizeCard(payload).subscribe(
      (data: any) => {
        this.loadingScreenService.stopLoading();
        const respString: string = this.encryptWithKeyService.decrypt(
          data.dataToken
        );

        try {
          const resp = JSON.parse(FlashPaymentUtil.formatEncryptData(respString));
          if (resp.hasError) {
            this.global.notif(resp.errorDisplay);
          } else {
            this.global.notif('Su medio de pago ha sido almacenado correctamente');
          }

        } catch (e) {
          this.service.decryptTokenByCrypto(data.dataToken).subscribe(
            (data: any) => {
              const respString: string = data.dataToken.replace('pIvhi9.qodmyxcyhqow.', "");
              const decryptedData = JSON.parse(atob(atob(atob(respString))));
              if (decryptedData.hasError) {
                this.global.notif(decryptedData.errorDisplay);
              } else {
                this.global.notif('Su medio de pago ha sido almacenado correctamente');
              }
            }, error => {
              // TODO
            }
          );
        }
      },
      (error) => {
        if (error.errorDisplay) {
          this.global.notif(error.errorDisplay);
        } else {
          this.global.notif('Su medio de pago no ha podido almacenarse correctamente.');
        }
        this.loadingScreenService.stopLoading();
      }
    );
  }

  processRedirectInfo(
    sessionToken,
    paymentId,
    typeResul,
    authorizationNumber = "",
    confirmationNumber = ""
  ) {
    this.getDataFromStorage();

    this.buildTransactionStatusRequest(
      paymentId,
      typeResul,
      authorizationNumber,
      confirmationNumber
    );
  }

  getDataFromStorage() {
    this.controller.newPaymentRequest = JSON.parse(
      sessionStorage.getItem("newPaymentRequest")
    );
    this.controller.doPaymentRequest = JSON.parse(
      sessionStorage.getItem("doPaymentRequest")
    );
    this.controller.operationAmount = sessionStorage.getItem("operationAmount");
    this.controller.userData = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    );
    this.controller.subscriberInfo = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo[0];
    this.controller = JSON.parse(sessionStorage.getItem("flash-data"));
    setTimeout(() => {
      sessionStorage.removeItem("flash-data");
    }, 500);
  }

  buildTransactionStatusRequest(
    paymentId,
    typeResult,
    authorizationNumber = "",
    confirmationNumber = ""
  ) {
    const payload: GetTransactionStatusRequest = {
      paymentId,
      paymentToken: "",
      bankToken: "",
      authorizationNumber: authorizationNumber,
      confirmationNumber: confirmationNumber,
    };
    let dto = this.encryptWithKeyService.encryp(JSON.stringify(payload));
    if (paymentId) {
      this.getTransactionStatus(dto, typeResult);
    } else {
      if (sessionStorage.getItem("paymentID")) {
        payload.paymentId = Number(sessionStorage.getItem("paymentID"));
        dto = this.encryptWithKeyService.encryp(JSON.stringify(payload));
        this.getTransactionStatus(dto, "");
      }
    }
  }

  getTransactionStatus(data, typeResult) {
    window.scroll(0, 700);
    this.loadingScreenService.startLoading();
    this.service.getTransactionStatus(data).subscribe(
      (data: any) => {
        const respString: string = this.encryptWithKeyService.decrypt(
          data.dataToken
        );
        try {
          const resp = JSON.parse(FlashPaymentUtil.formatEncryptData(respString));
          if (typeResult.toString().trim().toLowerCase() !== "cancel") {
            this.manageStatusResponse(resp);
          } else {
            this.manageErrorStatusResponse(resp);
          }
          this.loadingScreenService.stopLoading();
        } catch (e) {
          this.service.decryptTokenByCrypto(data.dataToken).subscribe(
            (data: any) => {
              const respString: string = data.dataToken.replace('pIvhi9.qodmyxcyhqow.', "");
              const decryptedData = JSON.parse(atob(atob(atob(respString))));
              this.loadingScreenService.stopLoading();
              if (decryptedData) {
                this.manageStatusResponse(decryptedData);
              }
            }, error => {
              // TODO
            }
          );
        }


      },
      (err) => {
        this.loadingScreenService.stopLoading();
        this.global.notif(err.error);
      }
    );
  }

  manageStatusResponse(resp) {
    if (resp.transactionInfo.payment.authorizationNumber) {
      this.controller.authorizationNumber =
        resp.transactionInfo.payment.authorizationNumber;
      this.controller.paymentMethod = resp.transactionInfo.payment.method.toString().trim().toUpperCase();
      ;
      //
      this.controller.paymentStatusDesription =
        //  resp.transactionInfo.StatusDesription;
        resp.errorSubject;
      if (!resp.hasError) {
        this.controller.confirmationNumber =
          resp.transactionInfo.provisioning.referenceSequenceCode;
        this.controller.paymentStatusDesription = this.personalizedMessages.okMessage;
        this.showLastStepOperation(1);

      } else {
        this.controller.errorMessage =
          resp.errorDisplay;
        this.showLastStepOperation(2);
      }
    } else {
      if (resp.transactionInfo.StatusId === 4) {
        this.controller.errorMessage = this.personalizedMessages.pendingMessage;
        this.showLastStepOperation(2);
      } else {
        if (resp.transactionInfo.StatusId === 5) {
          this.controller.errorMessage = this.personalizedMessages.rejectedMessage;
        } else {
          this.controller.errorMessage = resp.errorDisplay;
        }
        this.showLastStepOperation(3);
      }
    }
  }

  showLastStepOperation(index) {
    window.scroll(0, 1000);
    this.controller.step1 = false;
    this.controller.step2 = false;
    this.controller.step3 = true;
    this.controller.operationError = false;
    this.controller.operationSuccess = false;
    this.controller.operationWarning = false;
    if (index === 1) {
      this.controller.operationSuccess = true;
    } else if (index === 2) {
      this.controller.operationWarning = true;
    } else {
      this.controller.operationError = true;
    }

  }

  manageErrorStatusResponse(resp) {
    if (resp.errorDescription) {
      this.controller.errorMessage = resp.errorDisplay;
    }

    if (resp.errorDisplay) {
      this.controller.errorMessage = resp.errorDisplay;
    }

    this.showLastStepOperation(3);
  }

  paymentLogin(key) {
    this.service.getPaymentsOptions().subscribe(
      (data: any[]) => {
        let paymentOptions;
        data.forEach((element) => {
          if (element.description.toString().trim() === this.controller.transactionType.toString().trim()) {
            paymentOptions = element.paymentOptions;
          }
        });
        this.controller.paymentOptions = paymentOptions;
        this.activateOption(this.controller.paymentOptions);
      },
      (err) => {
        // Todo
      }
    );
  }

  activateOption(data) {
    this.controller.isACHVisible = false;
    this.controller.isCardVisible = false;
    this.controller.isPlaceToPayVisible = false;
    data.forEach(element => {
      if (element.merchantTypeCode === "ATH" || element.merchantTypeCode === "APICALLMETHOD") {
        this.controller.isCardVisible = true;
      }

      if (element.merchantTypeCode === "WALLET") {
        this.controller.isPlaceToPayVisible = true;
      }

      if (element.merchantTypeCode === "CHECKOUT") {
        this.controller.isACHVisible = true;
      }
    });
  }

  paymentKeepAlive() {
    this.service.flashPaymentKeepAlive(this.controller.paymentToken).subscribe(
      (data: any) => {
        // TODO
      },
      (err) => {
        // TODO
      }
    );
  }

  paymentLogout() {
    this.service.flashPaymentLogout(this.controller.paymentToken).subscribe(
      (data: any) => {
        this.controller.paymentToken = null;
        // TODO
      },
      (err) => {
        // TODO
      }
    );
  }

  achPayment() {
    this.global.newPayment(
      this.controller.newPaymentRequest.productId,
      this.controller.newPaymentRequest.typeMessage,
      this.controller.newPaymentRequest.currentBan,
      this.controller.newPaymentRequest.subscriber,
      this.controller.operationAmount.toString(),
      this.controller.newPaymentRequest.email,
      this.controller.newPaymentRequest.name,
      this.controller.newPaymentRequest.offerId,
      this.controller.newPaymentRequest.token,
      '',
      true
    );

    this.listenACH = this.global.achDataReceived.subscribe(
      (resp: any) => {
        this.achProcessDone(resp);
      }
    )
  }

  achProcessDone(resp) {
    this.listenACH.unsubscribe();
    if (resp.authorizationNumber !== '') {
      this.controller.authorizationNumber = resp.authorizationNumber;
      this.controller.paymentStatusDesription = resp.paymentStatus;
      this.controller.confirmationNumber = resp.confirmationNumber;

      if (this.controller.confirmationNumber !== '' && resp.hasError === false) {
        this.showLastStepOperation(1);
      } else {
        this.controller.errorMessage = resp.errorDisplay;
        this.showLastStepOperation(2);
      }
    } else {
      this.controller.errorMessage = resp.errorDisplay;
      this.showLastStepOperation(3);
    }
  }

  paymentProcess(typeMessage = "payment", productID = 1, offerId = "") {
    typeMessage === "prepaid"
      ? (this.controller.isPrepaid = true)
      : (this.controller.isPrepaid = false);
    const serviceComplementData = {
      typeMessage,
      productID,
      offerId,
    };
    this.controller.serviceComplementData = serviceComplementData;
    this.h2hMethod(productID, offerId, this.controller.operationAmount);
  }

  h2hMethod(productID, offerId, valueAmount) {
    this.loadingScreenService.startLoading();
    this.service.newPayment(productID, offerId).subscribe(
      (resp: any) => {
        this.loadingScreenService.stopLoading();
        // const index = resp.paymentOptions
        //   .map((x) => x.paymentOptionType.toLocaleLowerCase())
        //   .indexOf("h2h");
        if (
          this.controller.userData.AccounInfo.addressField &&
          this.controller.userData.AccounInfo.cityField &&
          this.controller.userData.AccounInfo.zIPField
        ) {
          this.controller.isValidAddress = true;
          this.controller.direction =
            this.controller.userData.AccounInfo.addressField;
          this.controller.town = this.controller.userData.AccounInfo.cityField;
          this.controller.PostalCode =
            this.controller.userData.AccounInfo.zIPField;
          this.readyTofillForm()

         // this.fillingApplyPaymentRequest(
         //   "10", // resp.paymentOptions[index].paymentOptionId,
         //   productID,
         //   offerId,
         //   valueAmount
         // );
        }
      },
      (error) => {
        this.loadingScreenService.stopLoading();
        // TODO
      }
    );
  }

  fillingApplyPaymentRequest(paymentOptionId, productId, offerId, valueAmount) {
    // this.getTransactionId().then();
    this.controller.accountNumber = atob(
      sessionStorage.getItem("currentBan")
    ).toString();
    const data: any = {
      recieverAcctNumber: "",
      receiverSubsNumber: "",
      merchantCodeId: "",
      productId: productId.toString(),
      paymentOptionId,
      paymentAmount: sessionStorage
        .getItem("operationAmount")
        .replace("CR", ""),
      customerEmail:  atob(sessionStorage.getItem("email")),
      subscriberNumber: atob(sessionStorage.getItem("currentSuscriber")),
      subscriberAccountNumber: atob(
        sessionStorage.getItem("currentBan")
      ).toString(),
      subscriberFullName:
        this.controller.userData.AccounInfo.firstNameField +
        " " +
        this.controller.userData.AccounInfo.lastNameField,
      subscriberAddress2: JSON.parse(sessionStorage.getItem("accountInfo"))
        .addressLinesField.line1Field,
      subscriberAddress1: JSON.parse(sessionStorage.getItem("accountInfo"))
        .addressLinesField.line2Field,
      subscriberCity: JSON.parse(sessionStorage.getItem("accountInfo"))
        .cityField,
      subscriberState: JSON.parse(sessionStorage.getItem("accountInfo"))
        .stateField,
      subscriberZipCode: JSON.parse(sessionStorage.getItem("accountInfo"))
        .zIPField,
      transactionDescription: "MICLARO STORE",
      extendedData: "",
    };
    this.executeApplyPayment(data, offerId);
  }

  executeApplyPayment(data, offerId) {
    this.loadingScreenService.startLoading();
    this.service
      .applyPayment(
        offerId,
        data.productId,
        data.paymentOptionId,
        data.paymentAmount,
        data.customerEmail,
        data.subscriberNumber,
        data.subscriberAccountNumber,
        data.subscriberFullName,
        data.subscriberAddress1,
        data.subscriberAddress2,
        data.subscriberCity,
        data.subscriberState,
        data.subscriberZipCode,
        data.transactionDescription,
        "",
        "",
        "",
        "",
        data.extendedData,
        ''
      )
      .subscribe(
        (resp: any) => {
          this.loadingScreenService.stopLoading();
          // this.readyTofillForm(resp);
        },
        (error) => {
          this.loadingScreenService.stopLoading();
          this.global.notif("A ocurrido un error intente nuevamente mas tarde");
        }
      );
  }

  readyTofillForm() {
    // this.controller.applyPaymentResponse = resp;
    this.controller.name = '';
      // JSON.parse(sessionStorage.getItem("accountInfo")).firstNameField +
      // " " +
      // JSON.parse(sessionStorage.getItem("accountInfo")).lastNameField;
    let year = Number(this.controller.jstoday.substring(6, 10));
    this.controller.years = [];
    for (let i = 0; i < 10; i++) {
      this.controller.years.push(year.toString());
      year++;
    }
  }

  autoFill() {
    setTimeout(() => {
      if (this.controller.useSavedInformation) {
        this.controller.direction = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).addressLinesField.line1Field;
        this.controller.direction2 = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).addressLinesField.line2Field;
        this.controller.state = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).stateField;
        this.controller.town = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).cityField;
        this.controller.PostalCode = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).zIPField;
        if (
          this.controller.direction === "" &&
          this.controller.direction2 !== ""
        ) {
          this.controller.direction = this.controller.direction2;
          this.controller.direction2 = "";
        }
      } else {
        this.controller.direction = "";
        this.controller.direction2 = "";
        this.controller.state = "";
        this.controller.town = "";
        this.controller.PostalCode = "";
      }
    }, 200);
  }

  executAuthorizePayment() {
    if (this.validateCreditCardForm()) {
      if (this.controller.athURL === null || this.controller.athURL === undefined) {
        this.loadingScreenService.startLoading();
        this.requestBodyCreationforAuthorizePayment().then(
          (result: any) => {
            if (!result.changeProcess) {
              // this.loadingScreenService.stopLoading();
              if (result.errorDescription) {
                this.global.notif(result.errorDescription);
              } else {
                this.controller.authorizationNumber = result.authorizationNumber;
                this.controller.paymentStatusDesription =
                  result.statusDescription;
                this.controller.step3 = true;
                this.controller.operationError = false;
                this.controller.operationSuccess = true;
                if (this.controller.paymentMethod === "V") {
                  this.controller.paymentMethod = "Visa";
                }
                if (this.controller.paymentMethod === "M") {
                  this.controller.paymentMethod = "Mastercard";
                }
                if (this.controller.paymentMethod === "X") {
                  this.controller.paymentMethod = "American Express";
                }
                if (this.controller.paymentMethod === "A") {
                  this.controller.paymentMethod = "ATH";
                }
              }
            } else {
              setTimeout(() => {
                // this.loadingScreenService.stopLoading()
              }, 2500)
            }

          },
          (error) => {
            this.loadingScreenService.stopLoading();
            this.global.notif(error);
            this.router.navigate(["login"]);
          }
        );
      } else {
        this.controller.canOpenAthPinPad = true;
        this.loadingScreenService.startLoading();
        setTimeout(() => {
          this.loadingScreenService.stopLoading();
        }, 3500);
      }
    }
  }

  requestBodyCreationforAuthorizePayment() {
    let h2hActive = false;
    if (h2hActive) {
      let index = 0;
      if (this.controller.isPrepaid) {
        index = this.controller.applyPaymentResponse.customerInfo
          .map((x) => x.accountNumber.toString())
          .indexOf(atob(sessionStorage.getItem("currentSuscriber")));
      } else {
        index = this.controller.applyPaymentResponse.customerInfo
          .map((x) => x.accountNumber.toString())
          .indexOf(this.controller.accountNumber.toString());
      }
      if (index === -1) {
        this.loadingScreenService.stopLoading();
        this.global.notif(
          `La cuenta: ${this.controller.accountNumber}, no ha llegado en la respuesta del servidor`
        );
        return;
      } else {
        const data = {
          data: "",
          filler1: this.controller.isPrepaid ? "PREPAGO" : "",
          paymentToken: this.controller.applyPaymentResponse.paymentToken,
          creditCardNumber: this.controller.cardNumber,
          paymentMethod: this.controller.paymentMethod,
          cardExpMonth: this.controller.expirationMonth,
          cardExpYear: this.controller.expirationYear,
          cardSecurityCode: this.controller.ccv,
          accountNumber: atob(sessionStorage.getItem("currentBan")),
          customerName: this.controller.name,
          customerEmail: atob(sessionStorage.getItem("email"))
            ? this.controller.userData.AccounInfo.emailField
            : "noEmail@claropr.com",
          address1: this.controller.direction
            ? this.controller.direction
            : this.controller.applyPaymentResponse.customerInfo[0].address1,
          address2: this.controller.direction2
            ? this.controller.direction2
            : this.controller.applyPaymentResponse.customerInfo[0].address2,
          city: this.controller.applyPaymentResponse.customerInfo[0].city,
          state: this.controller.applyPaymentResponse.customerInfo[0].state,
          zipCode: this.controller.PostalCode,
        };
        return this.getKey(data);
      }
    } else {
      if (this.count === 0) {
        this.count += 1;
        this.buildAuthorizationRequest(false, false, true);
      }


      const myPromise = new Promise((resolve, reject) => {
        resolve({
          changeProcess: true,
        });
      });
      return myPromise;
    }
  }

  async getKey(data) {
    try {
      const respKey: any = await this.service.getKeys().toPromise();
      this.encryptWithKeyService.setKeys(
        atob(respKey.sharedKey),
        atob(respKey.ivKey)
      );
      return this.service.authorizePayment(data).toPromise();
    } catch (error) {
      this.loadingScreenService.stopLoading();
      const result = {
        errorDisplay:
          "En estos momentos estamos presentando inconvenientes intente nuevamente más tarde",
      };
    }
  }

  downloadLastInvoice() {
    this.loadingScreenService.startLoading();
    this.service
      .downloadLastPdf(
        atob(sessionStorage.getItem("currentBan")).toString(),
        this.controller.jstoday.substring(6, 10),
        "pdf",
        sessionStorage.getItem("token")
      )
      .subscribe(
        (data: any) => {
          this.loadingScreenService.stopLoading();
          if (data.invoiceContent) {
            sessionStorage.setItem("invoiceContentDownload", data.invoiceContent);
            this.controller.invoiceContent = data.invoiceContent;
            this.openPdf();
          } else {
            this.global.notif('En estos momentos no esta la infromación disponible favor intente nuevamente mas tarde');
            return;
          }
        },
        (error) => {
          this.loadingScreenService.stopLoading();
          // TODO
          this.global.notif('Ha ocurrido un error por favor intente nuevamente mas tarde');
        }
      );
  }

  openPdf() {
    if (this.controller.invoiceContent) {
      let byteCharacters = atob(this.controller.invoiceContent);
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      let file = new Blob([byteArray], {type: "application/pdf;base64"});
      let fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } else {
      return;
    }
  }

  getLocalData() {
      this.service.getLocalData().subscribe(
        resp => {
          this.personalizedMessages = resp
        },
      error => {}
    );
  }
}
